<template>
  <IconLucideImages />
</template>
